import { render, staticRenderFns } from "./GroundTruthSummaryModal.vue?vue&type=template&id=ba41ca24&scoped=true&"
import script from "./GroundTruthSummaryModal.vue?vue&type=script&lang=js&"
export * from "./GroundTruthSummaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba41ca24",
  null
  
)

export default component.exports